/*
@ts-nocheck
 */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import _ from "lodash";
import styled from "styled-components";

import { arrayToOptions, interferance } from "components/pages/search-results-page";
import PaginationControl from "components/tools/pagination-control";
import { Control } from "components/ui-kit/control";
import { Breadcrumb, Container, Frame, RowWrapper } from "components/ui-kit/styled-templates";

import { resolveFileUrl } from "constants/config";

import EventsApi from "api/events-api";
import RoomsApi from "api/rooms-api";
import UniversityApi from "api/university-api";

import useBodyBackground from "hooks/useBodyBackground";
import useFormControl from "hooks/useFormControl";
import usePagination from "hooks/usePagination";
import { useStorageListener } from "hooks/useStorage";

import { EForms } from "types/enums";
import Select from "react-select";

// || "РОССИЯ"

const UniversitiesPage = () => {
    const { t } = useTranslation();

    useBodyBackground("white");

    const { data: search, setValues } = useFormControl({ name: EForms.universitiesSearch });

    const rooms = useStorageListener(`rooms`, {});
    const universities = useStorageListener(`universities`, {});
    const events = useStorageListener(`events`, {});

    // Проверяем, загружены ли все данные
    const isLoading = _.isEmpty(universities) || _.isEmpty(events);

    // Функция для получения события с самой поздней датой окончания (прошедшего модерацию)
    const getLatestEndingEvent = (universityId: string) => {
        const now = Date.now();
        const universityEvents = _.values(events)
            .filter((event: any) =>
                event.universityId === universityId &&
                event.onModeration !== true &&
                event.hideFromAll !== true &&
                (event.details?.dates?.to || event.details?.dates?.from) >= now
            )
            .sort((a: any, b: any) => (b.details?.dates?.to || b.details?.dates?.from || 0) - (a.details?.dates?.to || a.details?.dates?.from || 0));

        return universityEvents[0] || null;
    };
    // filteredUniversities = filteredUniversities.map(x => ({
    //     ...x,
    //     details: {
    //         ...x.details,
    //         country: x.details.country || "РОССИЯ",
    //     }
    // }));
// .map(x => ({
//         ...x,
//         details: {
//             ...x.details,
//             country: x.details.country || "РОССИЯ",
//         }
//     }))

    let filteredUniversities = _(universities)

        .filter(interferance("details.region", search.region))
        // .filter(interferance("details.city", search.city))
        .filter(interferance("details.city", search.city))
        // .filter(interferance("details.country", search.country))
        .filter((i) => {
            const uniRooms = _(rooms).filter({ universityId: i.id }).value();
            const uniRoomsTypes = _.uniq(_.map(uniRooms, "details.type"));
            return [...uniRoomsTypes, ``]?.includes?.(search.type ?? ``);
        })
        .value();

    // console.log('filteredUniversities = ', filteredUniversities);
    filteredUniversities = filteredUniversities.filter(x => (x?.hideFromAll != true));
    // filteredUniversities = filteredUniversities;

    // .map(x => ({
//         ...x,
//         details: {
//             ...x.details,
//             country: x.details.country || "РОССИЯ",
//         }
//     }));

    console.log('0) filteredUniversities = ', filteredUniversities);
    console.log('0-11 ) filteredUniversities = ', filteredUniversities.filter(x => (x?.details?.country == 'АБХАЗИЯ')));


    filteredUniversities = filteredUniversities.map(x => ({
        ...x,
        details: {
            ...x.details,
            country: x.details.country || "РОССИЯ"
        }
    }));

    console.log('1) filteredUniversities = ', filteredUniversities);
    // filter by country if filter selected
    if (search.country) {
        filteredUniversities = filteredUniversities.filter((i) => i.details.country === search.country);
    }

    // Сортировка ВУЗов: сначала те, у которых событие заканчивается позже всех
    filteredUniversities = filteredUniversities.sort((a, b) => {
        const eventA = getLatestEndingEvent(a.id);
        const eventB = getLatestEndingEvent(b.id);

        // ВУЗы с предстоящими событиями идут первыми
        if (eventA && !eventB) return -1;
        if (!eventA && eventB) return 1;

        // Оба имеют события — сортировать по дате окончания (позже = выше)
        if (eventA && eventB) {
            const endA = eventA.details?.dates?.to || eventA.details?.dates?.from || 0;
            const endB = eventB.details?.dates?.to || eventB.details?.dates?.from || 0;
            return endB - endA;
        }

        // Оба без событий — оставить как есть
        return 0;
    });

    const pagination = usePagination(_.values(filteredUniversities), { perPage: 9 });
    const { visibleItems: visibleUniversities } = pagination;

    // @ts-ignore
    useEffect(UniversityApi.getAllUniversitiesData, []);
    // @ts-ignore
    useEffect(RoomsApi.getAllRooms, []);
    // @ts-ignore
    useEffect(EventsApi.getEvents, []);

    const filteredOptions = {
        region: _(filteredUniversities).map("details.region").uniq().map(arrayToOptions).orderBy("label", "asc").value(),
        city: _(filteredUniversities).map("details.city").uniq().map(arrayToOptions).orderBy("label", "asc").value(),
        country: _(filteredUniversities).map("details.country").concat("РОССИЯ").concat("АБХАЗИЯ").uniq().map(arrayToOptions).orderBy("label", "asc").value(),
        // country: (_.get(universities, `${i.universityId}.details.country`) ?? _.get(i, "details.main-info.country")) || "РОССИЯ",
        type: _(rooms)
            .filter((i) => _.map(filteredUniversities, "id")?.includes?.(i?.universityId))
            .orderBy("details.type", "asc")
            .map("details.type")
            .uniq()
            .map(arrayToOptions)
            .orderBy("label", "asc")
            .value()
    };

    let filteredRegions = (filteredOptions?.region || []).sort((a, b) => {
        let s1 = a.value;
        let s2 = b.value;
        if (s1.indexOf("ЕА") > -1) {
            s1 = `_${s1}`;
        }
        if (s2.indexOf("ЕА") > -1) {
            s2 = `_${s2}`;
        }
        if (s1 > s2) {
            return 1;
        }
        if (s1 < s2) {
            return -1;
        }
        return 0;
    });

    useEffect(() => {
        // scroll to top after render and after article loaded
        try{
            setTimeout(() => {
                console.log('scroll to top!!!');
                window.scrollTo({
                    top: 0,
                    behavior: 'auto'
                });
                const element = document.getElementById("header_logo");
                if (element) {
                    element.scrollIntoView({
                        behavior: "auto", // Optional for smooth scrolling
                        block: "start",     // Aligns the element at the top
                    });
                }
            }, 100);
        }catch(exc){

        }
    }, []);

    return (
        <>
            <Container extra="align-items: flex-start; h1 { margin: 0; };">
                <Breadcrumb.Wrapper>
                    <Breadcrumb.Item to="/">{t("s7kasboi06")}</Breadcrumb.Item>
                    <Breadcrumb.Item to="/universities">{t("lhg3pp5hol")}</Breadcrumb.Item>
                </Breadcrumb.Wrapper>
                <h1>{t("ke55vanmdo")}</h1>
            </Container>
            <Form name={EForms.universitiesSearch}>
                <Container>
                    <Control.Row>
                        {/*<Control.Select*/}
                        {/*    name="region"*/}
                        {/*    placeholder={t("bo5x1ckzqn6")}*/}
                        {/*    options={filteredRegions}*/}
                        {/*    extra="input { background: white; border-radius: 4px; }"*/}
                        {/*    menuProps={{ extra: `> * { max-width: fit-content; }` }}*/}
                        {/*/>*/}

                        <div className={"sm:flex-1 block mb-2 w-full"}>
                            <Select
                                name="country"
                                placeholder={"Страна"}
                                options={filteredOptions.country}
                                isClearable={true}
                                onChange={x => {
                                    let val = x?.value;
                                    setValues({ ...search, country: val });
                                }}
                            />
                        </div>

                        <div className={"sm:flex-1 block mb-2 w-full"}>
                            <Select
                                name="region"
                                placeholder={t("bo5x1ckzqn6")}
                                options={filteredRegions}
                                isClearable={true}
                                onChange={x => {
                                    let val = x?.value;
                                    setValues({ ...search, region: val });
                                }}
                            />
                        </div>

                        <div className={"sm:flex-1 block mb-2 w-full"}>
                            <Select
                                name="city"
                                placeholder={t("ykxjslth2w")}
                                options={filteredOptions.city}
                                isClearable={true}
                                onChange={x => {
                                    let val = x?.value;
                                    setValues({ ...search, city: val });
                                }}
                            />
                        </div>

                        {/*<Control.Select*/}
                        {/*    name="city"*/}
                        {/*    placeholder={t("ykxjslth2w")}*/}
                        {/*    options={filteredOptions.city}*/}
                        {/*    extra="input { background: white; border-radius: 4px; }"*/}
                        {/*    menuProps={{ extra: `> * { max-width: fit-content; }` }}*/}
                        {/*/>*/}

                        <div className={"sm:flex-1 block mb-2 w-full"}>
                            <Select
                                name="type"
                                placeholder={t("3rkeb5jq2v")}
                                options={filteredOptions.type}
                                isClearable={true}
                                onChange={x => {
                                    let val = x?.value;
                                    setValues({ ...search, type: val });
                                }}
                            />
                        </div>

                        {/*<Control.Select*/}
                        {/*    name="type"*/}
                        {/*    placeholder={t("3rkeb5jq2v")}*/}
                        {/*    options={filteredOptions.type}*/}
                        {/*    extra="input { background: white; border-radius: 4px; }"*/}
                        {/*    menuProps={{ extra: `> * { max-width: fit-content; }` }}*/}
                        {/*/>*/}


                    </Control.Row>
                </Container>
            </Form>
            <Container
                className={"unis_wrapper"}
                extra="flex-direction: row; flex-wrap: wrap; justify-content: flex-start; width: 100%; gap: 15px; margin-top: 15px; a { width: calc((100% - 15px * 2) / 3); };"
            >
                {isLoading ? (
                    <LoadingIndicator>Загрузка...</LoadingIndicator>
                ) : (
                    visibleUniversities.map((university) => (
                        <Link className={"uni_link"} key={university.id} to={`/university/${university.id}`}>
                            <UniversitiesTab.Component university={university} />
                        </Link>
                    ))
                )}
            </Container>
            {!isLoading && (
                <Container>
                    <PaginationControl pagination={pagination} />
                </Container>
            )}
        </>
    );
};

const UniversitiesTab = {
    Component: (props) => {
        const { t } = useTranslation();

        const { university: universityProps } = props;
        const { details: university, id: universityId } = universityProps;
        const rooms = useStorageListener((state) => _.values(state?.rooms)?.filter((room) => room.universityId === universityId));
        const now = Date.now();
        const events = useStorageListener((state) => _.values(state?.events)?.filter((event) =>
            event.universityId === universityId &&
            event.onModeration !== true &&
            event.hideFromAll !== true &&
            (event.details?.dates?.to || event.details?.dates?.from) >= now
        ));
        return (
            <UniversitiesTab.Wrapper>
                <UniversitiesTab.Photo src={resolveFileUrl(_.get(university, "photo"))} />
                <UniversitiesTab.Body>
                    <h3>{_.get(university, "name")}</h3>
                    <div className="region">{_.get(university, "region")}</div>
                    <RowWrapper>
                        <div>{t("5apix89ohr9")}</div>
                        <strong>{rooms?.length}</strong>
                    </RowWrapper>
                    {/*<RowWrapper>*/}
                    {/*    <div>Доступно мест:</div>*/}
                    {/*    <strong>-</strong>*/}
                    {/*</RowWrapper>*/}
                    <RowWrapper>
                        <div>{t("8gn9igbauq8")}</div>
                        <strong>
                            {events.length} {t("awl9xdgtpsa")}
                        </strong>
                    </RowWrapper>
                </UniversitiesTab.Body>
            </UniversitiesTab.Wrapper>
        );
    },
    Wrapper: styled(Frame)`
      width: 100%;
      border-radius: 12px;
      overflow: hidden;
      border: 1px solid ${({ theme }) => theme.halfblue};
      box-sizing: border-box;
    `,
    Photo: styled(Frame)<{ src?: string }>`
      width: 100%;
      height: 224px;
      background: url("${({ src }) => src}") no-repeat center center / cover;
    `,
    Body: styled(Frame)`
      width: 100%;
      padding: 20px;
      box-sizing: border-box;
      align-items: flex-start;
      justify-content: flex-start;
      gap: 8px;

      * {
        display: flex;
      }

      h3 {
        margin: 8px 0;
      }

      .region {
        font-size: 13px;
        line-height: 17px;
        color: ${({ theme }) => theme.blue};
      }
    `
};

const Label = styled.div`
  color: rgb(33, 33, 33);
  margin-bottom: 8px;
  font-size: 14px;
`;

const Form = styled.form`
  display: flex;
  padding: 56px 0;
  width: 100%;
  background: ${({ theme }) => theme.lightblue};
  justify-content: center;
`;

const LoadingIndicator = styled.div`
  width: 100%;
  padding: 40px;
  text-align: center;
  font-size: 16px;
  color: #666;
`;

export default UniversitiesPage;
